import UtilsLib from 'utils/vue/lib/utils'
export default UtilsLib
export const {
  countries,
  states,
  parseNumber,
  getQS,
  get$,
  style$,
  html$,
  coerceBoolean,
  pushState,
  formatPrice,
  alert,
  confirm,
  emit,
  getEmitter
} = UtilsLib

